<script>
import AuthLayout from "@/Layouts/AuthLayout.vue";

export default {
    layout: AuthLayout,
};
</script>

<script setup>
import { Head, Link, useForm } from "@inertiajs/vue3";
import BrandButton from "@/Components/Brand/BrandButton.vue";
import BrandInput from "@/Components/Brand/BrandInput.vue";

defineProps({
    status: String,
});

const form = useForm({
    email: "",
});

const submit = () => {
    form.post(route("password.email"));
};
</script>

<template>
    <Head title="Forgot Password" />

    <div class="flex w-full flex-col items-center">
        <div class="flex w-full items-center gap-6 pl-[18px] md:w-auto md:pl-0">
            <img
                :src="asset('images/brand/logo-mark.png')"
                alt="Gift Hero"
                class="hidden size-[75px] shrink-0 object-contain md:block"
            />
            <h1
                class="font-brand-display text-[30px] font-black italic uppercase leading-none tracking-[-0.02em] text-white md:text-[32px]"
            >
                Forgot your<br />password?
            </h1>
        </div>

        <form
            class="mt-[38px] w-full max-w-[408px] rounded-brand bg-white p-[18px] shadow-[0px_30px_55px_0px_rgba(0,0,0,0.25)] sm:p-9 md:mt-7"
            @submit.prevent="submit"
        >
            <div
                v-if="status"
                class="mb-5 font-brand text-sm font-medium text-green-600"
            >
                {{ status }}
            </div>

            <p
                class="mb-5 font-brand text-[14px] leading-relaxed text-[#3c3938]"
            >
                No problem. Let us know your email address and we&rsquo;ll email
                you a link to choose a new one.
            </p>

            <div>
                <label
                    for="email"
                    class="mb-0.5 block font-brand text-[15px] font-bold leading-[19px] text-[#3c3938]"
                    >E-Mail Address</label
                >
                <BrandInput
                    id="email"
                    v-model="form.email"
                    type="email"
                    required
                    autofocus
                    autocomplete="email"
                />
                <p
                    v-if="form.errors.email"
                    class="mt-1.5 text-[13px] text-brand-red"
                >
                    {{ form.errors.email }}
                </p>
            </div>

            <BrandButton
                type="submit"
                class="mt-8 h-11 w-full text-[15px]"
                :class="{ 'pointer-events-none opacity-60': form.processing }"
                :disabled="form.processing"
                :loading="form.processing"
            >
                Email Password Reset Link
            </BrandButton>
        </form>

        <p class="mt-7 font-brand text-[15px] text-white md:mt-6">
            <span class="font-semibold">Remembered it?</span>
            <Link
                :href="route('login')"
                class="ml-1.5 !text-white underline hover:opacity-80"
                >Back to Log In</Link
            >
        </p>
    </div>
</template>
